import React, { useState, useCallback, useEffect } from 'react'
import { Formik, Form, Field } from 'formik'
import { useHistory, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useModal } from 'react-modal-hook'
import moment from 'moment'
import Modal from '../../components/Modal/Modal'
import InputError from '../../components/InputError/InputError'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoOTP from '../../components/FormComponents/NeoOTP'
import NeoSuccess from '../../components/FormComponents/NeoSuccess'
import NeoInput from '../../components/NeoInput/NeoInput'
import NeoLoader from '../../components/FormComponents/NeoLoader'
import NumberFormat from 'react-number-format'
import AccountDisplay from '../../components/account-display/account-display'
import TermsAndConditions from '../../components/TermsAndConditions/TermsAndCondition'
import { CreateStandingInstructionSchema } from '../../schemas/requests'
import LayoutWithAccountCard from '../Layout/layout-account-card'
import {
  getAccountListSelector,
  getCurrentAccDetailsSelector,
} from '../../store/selectors/app.selector'
import RequestService from '../../services/request.service'
import { BUTTON_KEYS, VALIDATION_KEYS, CREATE_SI_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'
import validationConfig from 'custom/config/validation.config.json'
import config from 'custom/config/environment'
const siConfig = validationConfig['OtherService']['standingInstructions']

export default function CreateStandingInstruction() {
  const [stage, setStage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [selectedAccount, setSelectedAccount] = useState('')
  const [selectedBank, setSelectedBank] = useState('')
  const [otp, setOtp] = useState('')
  const [randomKey, setRandomKey] = useState('')
  const [terms, setTerms] = useState('')
  const [monthEnd, setMonthEnd] = useState(false)
  const [requestType, setRequestType] = useState('')
  const [banks, setBanks] = useState({})
  const [message, setMessage] = useState('')
  const [otpEnabled, setOtpEnabled] = useState(false)
  const [verifyDetails, setVerifyDetails] = useState({})
  const { t } = useTranslation()

  const history = useHistory()
  const location = useLocation()

  const currentAccountDetail = useSelector(getCurrentAccDetailsSelector)
  const accounts = useSelector(getAccountListSelector) || []
  const [data, setData] = useState({ url: '', breadCrumb: '' })

  const [formValues, setFormValues] = useState({
    requestType: '',
    debitAccountNumber: '',
    creditAccountNumber: '',
    startDate: '',
    endDate: '',
    date: '',
    month: '',
    year: '',
    siAmount: '',
    remarks: '',
    monthEndFlag: false,
  })

  const [error, setError] = useState('Error has Occurred')
  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>{error?.message}</h6>
          <div className='modal-btn-style'>
            <NeoButton
              tabIndex='1'
              mode='newDesign'
              type='button'
              text={t(BUTTON_KEYS.OK)}
              onClick={() => {
                hideModal()
                // history.push('/requests')
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  useEffect(() => {
    // fetchPreFormData()
    location.pathname.includes('/requests') &&
      setData({ url: '/requests', breadCrumb: 'REQUESTS_SI_CREATE' })
    location.pathname.includes('/accounts') &&
      setData({ url: '/accounts', breadCrumb: 'ACCOUNTS_SI_CREATE' })
  }, [])

  const fetchPreFormData = useCallback(async () => {
    try {
      //   const response = await getAllBanks()
      //   const bankNames = {}
      //   response.map((value) => {
      //     if (Object.keys(bankNames).includes(value.bankName)) {
      //       bankNames[value.bankName].push({
      //         bankCode: value.bankCode,
      //         address: value.branchDesc,
      //       })
      //     }
      //     bankNames[value.bankName] = [
      //       {
      //         bankCode: value.bankCode,
      //         address: value.branchDesc,
      //       },
      //     ]
      //     return value
      //   })
      //   setBanks(bankNames)
    } catch (err) {
      // setError(err)
      // //showModal()
    }
  }, [showModal])

  function renderSwitch() {
    switch (stage) {
      case 1:
        return renderForm()
      case 2:
        return renderConfirmation()
      case 3:
        return <NeoOTP otp={otp} setOTP={setOtp} onSubmit={onConfirm} loading={loading} />
      case 4:
        return <NeoSuccess message={message} linkPath={`${data.url}/standing-instruction`} />
      default:
        return renderForm()
    }
  }

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const response = await RequestService.confirmSIRequest({
        amount: formValues.siAmount,
        destAccount: formValues.creditAccountNumber,
        // destAccBranch: '',
        // destAccCcy: '',
        expireDate: formValues.endDate,
        firstValDate: formValues.startDate,
        monthEndFlag: formValues.monthEndFlag ? 'Y' : 'N',
        remarks: formValues.remarks,
        bankCode: '',
        srcAccount: currentAccountDetail?.accountNo,
        srcAccBranch: currentAccountDetail?.brnCode,
        srcAccCcy: currentAccountDetail?.currency,
        transferType: 'IAT',
        days: formValues.monthEndFlag ? '' : formValues.date || '',
        months: formValues.monthEndFlag ? '' : formValues.month || '',
        years: formValues.monthEndFlag ? '' : formValues.year || '',
        bankCode: '',
        bankName: '',
        otp: otp,
        randomKey: verifyDetails.randomKey,
      })
      if (response.status === 200 || response.data.status === 200) {
        setMessage(response.data['message'])
        setLoading(false)
        setStage(4)
      }
    } catch (err) {
      // setError(err)
      setOtp('')
      setLoading(false)
      // //showModal()
    }
  }, [formValues, otp, banks, selectedBank, currentAccountDetail, verifyDetails])

  const onVerify = useCallback(
    async (values, { setSubmitting }) => {
      try {
        if (values.siAmount === '0.00' || values.siAmount === '.00') {
          return
        }
        setLoading(true)
        setSubmitting(true)
        setFormValues(values)
        const response = await RequestService.verifySIRequest({
          amount: values.siAmount,
          destAccount: values.creditAccountNumber,
          //   destAccBranch: '',
          //   destAccCcy: '',
          expireDate: values.endDate,
          firstValDate: values.startDate,
          monthEndFlag: values.monthEndFlag ? 'Y' : 'N',
          remarks: values.remarks,
          bankCode: '',
          srcAccount: currentAccountDetail?.accountNo,
          srcAccBranch: currentAccountDetail?.brnCode,
          srcAccCcy: currentAccountDetail?.currency,
          transferType: 'IAT',
          days: values.monthEndFlag ? '' : values.date || '',
          months: values.monthEndFlag ? '' : values.month || '',
          years: values.monthEndFlag ? '' : values.year || '',
          bankCode: '',
          bankName: '',
          otpNo: '',
          randomKey: '',
        })
        if (response.status === 200) {
          setStage(2)
          setLoading(false)
          setVerifyDetails(response.data)
          setOtpEnabled(response.data['otpEnable'])
          setSubmitting(false)
        }
      } catch (err) {
        // setError(err)
        setOtp('')
        setLoading(false)
        setSubmitting(false)
        // //showModal()
      }
    },
    [showModal, currentAccountDetail, accounts],
  )

  function renderBankAddresses() {
    if (selectedBank.length > 0) {
      return banks[selectedBank].map((bank, i) => (
        <option key={i} value={bank.address}>
          {bank.address}
        </option>
      ))
    }

    return null
  }

  function renderCreditField(errors, touched, setFieldValue) {
    if (requestType === 'OAT') {
      if (currentAccountDetail) {
        const creditAccounts = accounts.filter(
          (value) => value.accountNo !== currentAccountDetail?.accountNo,
        )
        return (
          <div>
            <label className='control-label'>
              Credit Account No. {siConfig['isAccountNoRequired'] ? '*' : ''}
            </label>
            <Field tabIndex={'2'} as='select' className='form-control' name='creditAccountNumber'>
              <option disabled value='' />
              {creditAccounts.map((acc, i) => (
                <option key={i} value={acc.accountNo}>
                  {acc.accountNo}
                </option>
              ))}
            </Field>
            <InputError text={errors.creditAccountNumber} touched={touched.creditAccountNumber} />
          </div>
        )
      }
      return (
        <div>
          <Field tabIndex={'2'} as='select' className='form-control' name='creditAccountNumber'>
            <option disabled value='' />
          </Field>
          <InputError text={errors.creditAccountNumber} touched={touched.creditAccountNumber} />
        </div>
      )
    }
    return (
      <div>
        <NeoInput
          showAsterisk={siConfig['isAccountNoRequired']}
          text={t(CREATE_SI_KEYS.CREDIT_ACC_NO)}
          mode='onlyNumber'
          maxLength={config.ACC_NO_LENGTH}
          onChange={(value) => {
            setFieldValue('creditAccountNumber', value?.value)
          }}
          name='creditAccountNumber'
        />
        {/* <Field as='input' maxLength='13' className='form-control' name='creditAccountNumber' /> */}
        <InputError text={errors.creditAccountNumber} touched={touched.creditAccountNumber} />
      </div>
    )
  }

  function renderForm() {
    return (
      <div>
        <div className='heading-style'>{t(CREATE_SI_KEYS.TITLE)}</div>
        <AccountDisplay currentAccountDetail={currentAccountDetail} />
        <Formik
          initialValues={formValues}
          enableReinitialize
          validationSchema={CreateStandingInstructionSchema}
          onSubmit={onVerify}>
          {({ isSubmitting, handleChange, errors, values, touched, setFieldValue }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-12'>
                  <label className='control-label'>
                    {t(CREATE_SI_KEYS.REQUEST_TYPE)} {siConfig['isRequestTypeRequired'] ? '*' : ''}
                  </label>
                  <Field
                    tabIndex={'1'}
                    as='select'
                    className='form-control'
                    name='requestType'
                    onChange={(e) => {
                      setRequestType(e.target.value)
                      handleChange(e)
                    }}>
                    <option disabled value='' />
                    <option value='IAT'>{t(CREATE_SI_KEYS.REQUEST_TYPE_OPTION)}</option>
                  </Field>
                  <InputError text={errors.requestType} touched={touched.requestType} />
                </div>
              </div>
              <div className='row'>
                <div className='form-group col-12'>
                  {renderCreditField(errors, touched, setFieldValue)}
                </div>
              </div>

              {values.requestType === 'DDACC' && (
                <div className='row'>
                  <div className='form-group col-12'>
                    <label className='control-label'>{t(CREATE_SI_KEYS.SELECT_BANK)}</label>
                    <Field
                      tabIndex={'3'}
                      as='select'
                      className='form-control'
                      name='bankName'
                      onChange={(e) => {
                        setSelectedBank(e.target.value)
                        handleChange(e)
                      }}>
                      <option disabled value='' />
                      {Object.keys(banks).map((bankName, i) => (
                        <option key={i} value={bankName}>
                          {bankName}
                        </option>
                      ))}
                    </Field>
                    <InputError text={errors.bankName} touched={touched.bankName} />
                  </div>

                  <div className='form-group col-12'>
                    {config.CLIENT_NAME !== 'NBS' ? (
                      <>
                        <label className='control-label'>{t(CREATE_SI_KEYS.SELECT_BRANCH)}</label>
                        <Field
                          tabIndex={'4'}
                          as='select'
                          className='form-control'
                          name='branchName'>
                          <option disabled value='' />
                          {renderBankAddresses()}
                        </Field>{' '}
                      </>
                    ) : (
                      <NeoInput
                        tabIndex='6'
                        showAsterisk={instantTransferConfig['isBranchRequired']}
                        text={t(QUICK_PAY_KEYS.SELECT_BRANCH)}
                        name='branchName'
                        value={values.branchName}
                        onChange={handleChange}
                      />
                    )}
                    <InputError text={errors.branchName} touched={touched.branchName} />
                  </div>
                </div>
              )}

              <div className='row'>
                <div className='form-group col-6'>
                  <label className='control-label'>
                    {t(CREATE_SI_KEYS.START_DATE)} {siConfig['isStartDateRequired'] ? '*' : ''}
                  </label>
                  <Field
                    tabIndex={'5'}
                    as='input'
                    className='form-control'
                    type='date'
                    name='startDate'
                    min={moment(new Date()).format('YYYY-MM-DD')}
                  />
                  <InputError text={errors.startDate} touched={touched.startDate} />
                </div>
                <div className='form-group col-6'>
                  <label className='control-label'>
                    {t(CREATE_SI_KEYS.END_DATE)} {siConfig['isEndDateRequired'] ? '*' : ''}
                  </label>
                  <Field
                    tabIndex={'6'}
                    as='input'
                    className='form-control'
                    type='date'
                    name='endDate'
                    min={moment(new Date()).format('YYYY-MM-DD')}
                  />
                  <InputError text={errors.endDate} touched={touched.endDate} />
                </div>
                {config.MONTHEND && (
                  <div className='form-group col-12'>
                    <div className='form-check'>
                      <Field
                        tabIndex={'7'}
                        as='input'
                        type='checkbox'
                        className='form-check-input'
                        name='monthEndFlag'
                        id='gridCheck'
                      />
                      <label className='form-check-label control-label' htmlFor='gridCheck'>
                        {t(CREATE_SI_KEYS.MONTH_END)}
                      </label>
                    </div>
                  </div>
                )}
              </div>
              {!values.monthEndFlag ? (
                <div className='row'>
                  <div className='form-group col-4'>
                    <NeoInput
                      tabIndex='8'
                      text={t(CREATE_SI_KEYS.DAYS)}
                      mode='onlyNumber'
                      onChange={(value) => {
                        setFieldValue('date', value?.value)
                      }}
                      name='date'
                    />
                    {/* <label className='control-label'>Days</label>
                    <Field
                      as='input'
                      type='number'
                      mode= 'onlyNumber'
                      className='form-control'
                      name='date'
                
                      onChange={(e) => {
                        if (parseInt(e.target.value) >= 0) {
                          setFieldValue('date', e.target.value)
                        }
                      }}
                    /> */}
                  </div>
                  <div className='form-group col-4'>
                    <NeoInput
                      tabIndex='9'
                      text={t(CREATE_SI_KEYS.MONTH)}
                      mode='onlyNumber'
                      onChange={(value) => {
                        setFieldValue('month', value?.value)
                      }}
                      name='month'
                    />
                    {/* <label className='control-label'>Month</label>
                    <Field
                      as='input'
                      type='number'
                      className='form-control'
                      name='month'
                      onChange={(e) => {
                        if (parseInt(e.target.value) >= 0) {
                          setFieldValue('month', e.target.value)
                        }
                      }}
                    /> */}
                  </div>
                  <div className='form-group col-4'>
                    <NeoInput
                      tabIndex='10'
                      text={t(CREATE_SI_KEYS.YEAR)}
                      mode='onlyNumber'
                      onChange={(value) => {
                        setFieldValue('year', value?.value)
                      }}
                      name='year'
                    />
                    {/* <label className='control-label'>Year</label>
                    <Field
                      as='input'
                      type='number'
                      className='form-control'
                      name='year'
                      onChange={(e) => {
                        if (parseInt(e.target.value) >= 0) {
                          setFieldValue('year', e.target.value)
                        }
                      }}
                    /> */}
                  </div>
                  <div className='col-12'>
                    <InputError
                      text={t(VALIDATION_KEYS.DAY_MONTH_YEAR_ONE_FIELD)}
                      touched={
                        (touched.date || touched.month || touched.year) &&
                        values.date == '' &&
                        values.month == '' &&
                        values.year == ''
                      }
                    />
                    <InputError
                      text={t(VALIDATION_KEYS.DAY_MONTH_YEAR_EQUAL_MORE)}
                      touched={
                        (touched.date || touched.month || touched.year) &&
                        (parseInt(values.date) <= 0 ||
                          parseInt(values.month) <= 0 ||
                          parseInt(values.year) <= 0)
                      }
                    />
                    <InputError
                      text={t(VALIDATION_KEYS.DAY_MONTH_YEAR_ONE_FIELD)}
                      touched={
                        ((touched.date || touched.month || touched.year) &&
                          values.date.length > 0 &&
                          values.month.length > 0 &&
                          values.year.length > 0) ||
                        (values.date.length > 0 && values.month.length > 0) ||
                        (values.date.length > 0 && values.year.length > 0) ||
                        (values.month.length > 0 && values.year.length > 0)
                      }
                    />
                    <InputError
                      text={t(VALIDATION_KEYS.DAY_MONTH_YEAR_MAX_VALUE)}
                      touched={
                        (touched.date || touched.month || touched.year) &&
                        (parseInt(values.date) > 365 ||
                          parseInt(values.month) > 24 ||
                          parseInt(values.year) > 5)
                      }
                    />
                  </div>
                </div>
              ) : null}
              <div className='row'>
                <div className='form-group col-12'>
                  <NeoInput
                    tabIndex='11'
                    showAsterisk={siConfig['isAmountRequired']}
                    mode='amount'
                    text={t(CREATE_SI_KEYS.AMOUNT)}
                    onChange={(values) => {
                      setFieldValue('siAmount', values.value)
                    }}
                    name='amount'
                  />
                  <InputError text={errors.siAmount} touched={touched.siAmount} />
                  <InputError
                    text={t(VALIDATION_KEYS.TRANSFER_AMOUNT_VALIDATION)}
                    touched={values.siAmount === '0.00' || values.siAmount === '.00'}
                  />
                  {/* <InputError
                    text={'Insufficient Balance in Selected Account'}
                    touched={parseInt(currentAccountDetail?.ODBAL) <= parseInt(values.siAmount)}
                  /> */}
                </div>
                <div className='form-group col-12'>
                  <label className='control-label'>
                    {t(CREATE_SI_KEYS.REMARK)} {siConfig['isRemarksRequired'] ? '*' : ''}
                  </label>
                  <Field
                    tabIndex={'12'}
                    as='input'
                    className='form-control'
                    name='remarks'
                    minLength='2'
                    maxLength='40'
                    onKeyPress={(event) => {
                      if (
                        !(event.charCode >= 65 && event.charCode <= 90) &&
                        !(event.charCode >= 97 && event.charCode <= 122) &&
                        event.charCode !== 32
                      ) {
                        event.preventDefault()
                      }
                    }}
                  />
                  <InputError text={errors.remarks} touched={touched.remarks} />
                </div>
              </div>
              <div className='mt-5'>
                {loading ? (
                  <NeoLoader />
                ) : (
                  <NeoButton
                    tabIndex='13'
                    mode={'newDesign'}
                    type='submit'
                    disabled={isSubmitting}
                    text={t(BUTTON_KEYS.SUBMIT)}
                  />
                )}
              </div>
              <div className='back-cancel-btn-container'>
                <button
                  tabIndex={'14'}
                  className='back-cancel-btn btn btn-sm new-design-warning-text-color'
                  onClick={() => history.goBack()}>
                  {t(BUTTON_KEYS.CANCEL)}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  function renderConfirmation() {
    return (
      <div className='d-flex flex-column confirmation'>
        <h3>{t(CREATE_SI_KEYS.CONFIRM_TITLE)}</h3>

        <AccountDisplay currentAccountDetail={currentAccountDetail} />

        <div>
          <h6 className='label'>{t(CREATE_SI_KEYS.REQUEST_TYPE)}</h6>
          <h6 className='value'>
            {formValues.requestType === 'IAT'
              ? 'Internal Account Transfer'
              : formValues.requestType === 'OAT'
              ? 'Own Account Transfer'
              : 'Domestic Transfers'}
          </h6>
        </div>
        <div>
          <h6 className='label'>{t(CREATE_SI_KEYS.CREDIT_ACCOUNT_NO)}</h6>
          <h6 className='value'>{formValues.creditAccountNumber}</h6>
        </div>
        <div>
          <h6 className='label'>{t(CREATE_SI_KEYS.START_DATE)}</h6>
          <h6 className='value'>{moment(formValues.startDate).format('DD-MM-YYYY')}</h6>
        </div>
        <div>
          <h6 className='label'>{t(CREATE_SI_KEYS.END_DATE)}</h6>
          <h6 className='value'>{moment(formValues.endDate).format('DD-MM-YYYY')}</h6>
        </div>
        {!formValues.monthEndFlag ? (
          <div>
            {formValues.date && (
              <div>
                <h6 className='label'>{t(CREATE_SI_KEYS.DAYS)}</h6>
                <h6 className='value'>{formValues.date || '-'}</h6>
              </div>
            )}

            {formValues.month && (
              <div>
                <h6 className='label'>{t(CREATE_SI_KEYS.MONTH)}</h6>
                <h6 className='value'>{formValues.month || '-'}</h6>
              </div>
            )}

            {formValues.year && (
              <div>
                <h6 className='label'>{t(CREATE_SI_KEYS.YEAR)}</h6>
                <h6 className='value'>{formValues.year || '-'}</h6>
              </div>
            )}
          </div>
        ) : null}
        <div>
          <h6 className='label'>{t(CREATE_SI_KEYS.AMOUNT)}</h6>
          <h6 className='value'>
            <NumberFormat
              value={formValues.siAmount}
              displayType={'text'}
              thousandSeparator={true}
              prefix={''}
              fixedDecimalScale={true}
              decimalScale={2}
              allowEmptyFormatting
            />
          </h6>
        </div>

        <div>
          <h6 className='label'>{t(CREATE_SI_KEYS.REMARK)}</h6>
          <h6 className='value'>{formValues.remarks}</h6>
        </div>
        {config.MONTHEND && (
          <div>
            <h6 className='label'>
              {t(CREATE_SI_KEYS.MONTH_END)} {formValues.monthEnd}
            </h6>
            <h6 className='value'>{formValues.monthEndFlag ? 'Yes' : 'No'}</h6>
          </div>
        )}
        <div>
          <TermsAndConditions module='STANDINGINSTRUCTION' />
        </div>
        <div className='mt-3'>
          {loading ? (
            <NeoLoader />
          ) : (
            <NeoButton
              type='button'
              text={t(BUTTON_KEYS.CONFIRM)}
              mode={'newDesign'}
              onClick={() => (otpEnabled ? setStage(3) : onConfirm())}
            />
          )}
        </div>
        <div className='back-cancel-style' onClick={() => setStage(1)}>
          {t(BUTTON_KEYS.BACK)}
        </div>
      </div>
    )
  }

  return (
    <LayoutWithAccountCard breadCumKey={data.breadCrumb}>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithAccountCard>
  )
}
